/* ============================================= */
/*  Use this template if you're adding an entry. */
/* 

          <div className='slide-item-cont'>
            <div id='slideItem'>
              <div
                className='col col-1'
                style={{
                  backgroundImage: `url(${NewsImage_2})`,
                  backgroundSize: "contain",
                }}
              ></div>
              <div className='col col-2'>
                <div className='date-container'>DATE</div>
                <div className='title-container'>
                  TITLE
                </div>
                <div className='text-container'>
                  DESCRIPTION
                </div>
              </div>
            </div>
          </div>

*/
/*  Paste this inside the <Slider /> component. */
/* ============================================= */

import React, { Component, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ArrowLeftCircle, ArrowRightCircle } from "react-feather";

// News Images

import NewsImage_1 from "../assets/images/news/img-news-1.png";
import NewsImage_2 from "../assets/images/news/img-news-2.png";

// Arrows

const prevArrowProps = {
  isHovered: false,
  initialStyle: {
    display: "block",
    color: "var(--secondary)",
    left: "2.5%",
    zIndex: 9,
    transition: "all 0.3s ease-in-out",
  },
  hoveredStyle: {
    display: "block",
    color: "var(--primary)",
    left: "2.5%",
    zIndex: 9,
    transition: "all 0.3s ease-in-out",
  },
};

const nextArrowProps = {
  isHovered: false,
  initialStyle: {
    display: "block",
    color: "var(--secondary)",
    right: "2.5%",
    zIndex: 9,
    transition: "all 0.3s ease-in-out",
  },
  hoveredStyle: {
    display: "block",
    color: "var(--primary)",
    right: "2.5%",
    zIndex: 9,
    transition: "all 0.3s ease-in-out",
  },
};

function NextArrow(props) {
  const { className, style, onClick } = props;
  const [isHovered, setIsHovered] = useState(false);
  return (
    <ArrowRightCircle
      className={className}
      style={
        !isHovered ? nextArrowProps.initialStyle : nextArrowProps.hoveredStyle
      }
      onClick={onClick}
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  const [isHovered, setIsHovered] = useState(false);
  return (
    <ArrowLeftCircle
      className={className}
      style={
        !isHovered ? prevArrowProps.initialStyle : prevArrowProps.hoveredStyle
      }
      onClick={onClick}
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    />
  );
}

export default class SimpleSlider extends Component {
  render() {
    const settings = {
      className: "",
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    };
    return (
      <div className='slider-container'>
        <Slider {...settings}>
          <div className='slide-item-cont'>
            <div id='slideItem'>
              <div
                className='col col-1'
                style={{
                  backgroundImage: `url(${NewsImage_1})`,
                  backgroundSize: "contain",
                }}
              ></div>
              <div className='col col-2'>
                <div className='date-container'>December 7, 2017</div>
                <div className='title-container'>
                  GETWELL HEALTH SYSTEMS INC. @ 15
                </div>
                <div className='text-container'>
                  A milestone of recognizing loyalty and longevity of services
                  to its accredited providers, valued clients and members. The
                  said event was held last December 5, 2017 at Marco Polo,
                  Ortigas, Pasig City.
                </div>
              </div>
            </div>
          </div>
          <div className='slide-item-cont'>
            <div id='slideItem'>
              <div
                className='col col-1'
                style={{
                  backgroundImage: `url(${NewsImage_2})`,
                  backgroundSize: "contain",
                }}
              ></div>
              <div className='col col-2'>
                <div className='date-container'>December 12, 2011</div>
                <div className='title-container'>
                  Getwell 10th Year Anniversary
                </div>
                <div className='text-container'>
                  A Decade of Excellence" in providing Quality & Affordable
                  Healthcare for the Filipino worker. Held at Abeerden Court,
                  Quezon City Last December 12, 2011.
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}
